"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _Funnel = _interopRequireDefault(require("../../Funnel"));

var _jsxRuntime = require("react/jsx-runtime");

var Transition = /*#__PURE__*/_react.default.forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Slide.default, (0, _extends2.default)({
    direction: "up",
    ref: ref
  }, props));
});

var ComponentBlockDialog = function ComponentBlockDialog(_ref) {
  var open = _ref.open,
      handleClose = _ref.handleClose,
      handleSave = _ref.handleSave,
      config = _ref.config;

  var handleClickSave = function handleClickSave() {
    handleSave(config.valueName);
    handleClose();
  };

  var subContext = /*#__PURE__*/_react.default.createContext({
    config: config
  });

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.default, {
    fullScreen: true,
    fullWidth: true,
    open: open,
    onClose: handleClose,
    TransitionComponent: Transition,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Funnel.default // Since we emulate a sub funnel, we need to mock the configuration context
      , {
        configurationContext: subContext,
        progressStepperVariant: "text",
        onComplete: handleClickSave,
        configKey: "items"
      })
    })
  });
};

var _default = ComponentBlockDialog;
exports.default = _default;